export default "__VITE_ASSET__657d5185__"